// Presupuestos mensuales por tipo de gasto (comida, antojos, transporte...).
// Son "fijos pero no fijos": sabes cuánto quieres gastar al mes, pero se gasta de a poco
// y en cualquier momento. Por eso lo que importa es verlo AL REGISTRAR el gasto.
import { claveMes } from './format';

const num = (n) => Number(n || 0);

export const ICONOS_PRESUPUESTO = ['🧺', '🍔', '🍕', '🥤', '🚕', '💊', '🎁', '👗', '🏠', '🐶', '📚', '🎬', '☕', '💅'];

// Cuánto se lleva gastado de cada presupuesto en un mes.
export function gastadoPorPresupuesto(movimientos, clave) {
  const r = {};
  movimientos
    .filter(m => m.tipo === 'egreso' && m.presupuesto_id && claveMes(m.fecha) === clave)
    .forEach(m => { r[m.presupuesto_id] = (r[m.presupuesto_id] || 0) + num(m.monto); });
  return r;
}

// Los gastos de un presupuesto en un mes, del más reciente al más antiguo.
export function gastosDelPresupuesto(movimientos, presupuestoId, clave) {
  return movimientos
    .filter(m => m.tipo === 'egreso' && m.presupuesto_id === presupuestoId && claveMes(m.fecha) === clave)
    .sort((a, b) => (b.fecha || '').localeCompare(a.fecha || ''));
}

// Estado de un presupuesto: cuánto va, cuánto queda y qué color le toca.
// Verde hasta el 80%, amarillo desde ahí, rojo al pasarse.
export function estadoPresupuesto(presupuesto, gastado) {
  const tope = num(presupuesto.monto_mensual);
  const usado = num(gastado);
  const restante = tope - usado;
  const pct = tope > 0 ? (usado / tope) * 100 : 0;
  return {
    tope,
    usado,
    restante,
    pct,
    pasado: pct >= 100,
    color: pct >= 100 ? 'var(--danger)' : pct >= 80 ? 'var(--warning)' : 'var(--success)',
  };
}

export function totalesPresupuestos(presupuestos, gastado) {
  const tope = presupuestos.reduce((s, p) => s + num(p.monto_mensual), 0);
  const usado = presupuestos.reduce((s, p) => s + num(gastado[p.id]), 0);
  return { tope, usado, restante: tope - usado, pct: tope > 0 ? (usado / tope) * 100 : 0 };
}
